import {
  AppShellProps as MantineAppShellProps,
  AppShell as MantineAppShell,
  AppShellHeaderProps as MantineAppShellHeaderProps,
  AppShellHeader as MantineAppShellHeader,
  AppShellNavbarProps as MantineAppShellNavbarProps,
  AppShellNavbar as MantineAppShellNavbar,
  AppShellMainProps as MantineAppShellMainProps,
  AppShellMain as MantineAppShellMain,
  AppShellAsideProps as MantineAppShellAsideProps,
  AppShellAside as MantineAppShellAside,
  AppShellFooterProps as MantineAppShellFooterProps,
  AppShellFooter as MantineAppShellFooter,
  AppShellSectionProps as MantineAppShellSectionProps,
  AppShellSection as MantineAppShellSection,
} from '@mantine/core';

export type AppShellProps = MantineAppShellProps;
export type AppShellHeaderProps = MantineAppShellHeaderProps;
export type AppShellNavbarProps = MantineAppShellNavbarProps;
export type AppShellMainProps = MantineAppShellMainProps;
export type AppShellAsideProps = MantineAppShellAsideProps;
export type AppShellFooterProps = MantineAppShellFooterProps;
export type AppShellSectionProps = MantineAppShellSectionProps;

export const AppShellHeader = MantineAppShellHeader;
AppShellHeader.displayName = 'AppShellHeader';

export const AppShellNavbar = MantineAppShellNavbar;
AppShellNavbar.displayName = 'AppShellNavbar';

export const AppShellMain = MantineAppShellMain;
AppShellMain.displayName = 'AppShellMain';

export const AppShellAside = MantineAppShellAside;
AppShellAside.displayName = 'AppShellAside';

export const AppShellFooter = MantineAppShellFooter;
AppShellFooter.displayName = 'AppShellFooter';

export const AppShellSection = MantineAppShellSection;
AppShellSection.displayName = 'AppShellSection';

export const AppShell = MantineAppShell;
AppShell.displayName = 'AppShell';

// Attach subcomponents to AppShell for dot notation access
AppShell.Header = AppShellHeader;
AppShell.Navbar = AppShellNavbar;
AppShell.Main = AppShellMain;
AppShell.Aside = AppShellAside;
AppShell.Footer = AppShellFooter;
AppShell.Section = AppShellSection;
